import { getTestsForProfession } from "../constants/testCatalog";
import { normalizeTestIds } from "./normalizeTestIds";

export function getCorrectedSessionEntriesForProfession(professionId, session) {
  return getTestsForProfession(professionId)
    .filter(function (test) {
      return session.isCorrected(test.value);
    })
    .map(function (test) {
      const entry = session.getCorrection(test.value);
      return {
        testValue: test.value,
        label: test.label,
        slug: test.slug,
        id: entry ? entry.id : null,
      };
    })
    .filter(function (entry) {
      return Boolean(entry.id);
    });
}

export function getCorrectedTestIdsForProfession(professionId, session) {
  return normalizeTestIds(
    getCorrectedSessionEntriesForProfession(professionId, session).map(
      function (entry) {
        return entry.id;
      }
    )
  );
}

export function getPendingTestsForProfession(professionId, session) {
  return getTestsForProfession(professionId).filter(function (test) {
    return (
      !session.isCorrected(test.value) && !session.isBlocked(test.value)
    );
  });
}

export function getCorrectedTestsForProfession(professionId, session) {
  return getTestsForProfession(professionId).filter(function (test) {
    return session.isCorrected(test.value);
  });
}

export function getSessionProgressItems(professionId, session, activeTestSlug) {
  return getTestsForProfession(professionId).map(function (test) {
    return {
      slug: test.slug,
      label: test.label,
      corrected: session.isCorrected(test.value),
      blocked: session.isBlocked(test.value),
      active: test.slug === activeTestSlug,
    };
  });
}
